import { type MutationError, trpc } from '@/shared/api';

interface UseSetPriceTiersOptions {
  readonly onSuccess?: () => void;
}

/** 수량 구간별 단가 저장 — 첫 구간 시작 수량은 서버가 검증한다. */
export const useSetPriceTiers = ({ onSuccess }: UseSetPriceTiersOptions = {}) => {
  const mutation = trpc.productManagement.products.setPriceTiers.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    setPriceTiers: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
